module.exports = "images/location_school.879267f1faeffb9464d9fe7bed5b1489.png";